import { render, staticRenderFns } from "./Histogram.vue?vue&type=template&id=7ef1c29b&scoped=true"
import script from "./Histogram.vue?vue&type=script&lang=js"
export * from "./Histogram.vue?vue&type=script&lang=js"
import style0 from "./Histogram.vue?vue&type=style&index=0&id=7ef1c29b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ef1c29b",
  null
  
)

export default component.exports